import { BaseApiService } from '@/shared/api/services/base.service';
import type { TokenWalletScope } from '@/features/payment/api/purchase';
import { buildUrl } from '@/shared/lib/query-params';
import type {
  TokenPackagesResponse,
  TokenBalanceResponse,
  TokenPurchaseResponse,
  TokenPurchasesResponse,
} from '@/types/tokens';

class TokensService extends BaseApiService {
  /**
   * `scope: 'api'` asks for the same packages priced the same way, but with
   * availability judged against the agent wallet (docs/agent-api/ADR-002) —
   * otherwise a full human balance would block an agent top-up.
   */
  async getPackages(scope?: TokenWalletScope): Promise<TokenPackagesResponse> {
    return this.httpGet<TokenPackagesResponse>(
      scope === 'api' ? '/v1/tokens/packages?scope=api' : '/v1/tokens/packages'
    );
  }

  async getBalance(): Promise<TokenBalanceResponse> {
    return this.httpGet<TokenBalanceResponse>('/v1/tokens/balance');
  }

  async getPurchaseHistory(params?: {
    page?: number;
    per_page?: number;
  }): Promise<TokenPurchasesResponse> {
    const url = buildUrl('/v1/tokens', {
      page: params?.page ? { number: params.page } : undefined,
      per_page: params?.per_page,
    });
    return this.httpGet<TokenPurchasesResponse>(url);
  }

  async getPurchase(purchaseId: string): Promise<TokenPurchaseResponse> {
    return this.httpGet<TokenPurchaseResponse>(`/v1/tokens/${purchaseId}`);
  }

}

export const tokensService = new TokensService();
